module.exports = __webpack_public_path__ + "static/media/LitmapsLogo_White.291bfeb2.svg";